export default "/images/vendor/flag-icon-css/flags/1x1/sc.svg?e623a69c2c715916a8df26f7994624ee";